// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  BugReportRole,
} from "./types";


export default __t.row({
  identity: __t.identity().primaryKey(),
  orgId: __t.string().name("org_id"),
  get role() {
    return BugReportRole;
  },
  displayName: __t.option(__t.string()).name("display_name"),
  email: __t.option(__t.string()),
  createdAt: __t.timestamp().name("created_at"),
  lastSeenAt: __t.timestamp().name("last_seen_at"),
  stamp: __t.option(__t.string()),
});
